module.exports = __webpack_public_path__ + "img/thinking-4.f32517af.png";